import { SMART_FILTERS, type SmartFilterId } from 'markcat-domain';
import styles from './SmartFilters.module.css';
import nav from './SidebarNav.module.css';
import { SidebarSection } from './SidebarSection';
import { ChevronRightIcon } from './icons';

interface SmartFiltersProps {
  counts: Record<SmartFilterId, number>;
  selectedId: SmartFilterId | null;
  onSelect: (id: SmartFilterId | null) => void;
  onOpenReview?: () => void;
  reviewActive?: boolean;
}

export function SmartFilters({ counts, selectedId, onSelect, onOpenReview, reviewActive = false }: SmartFiltersProps) {
  const visible = SMART_FILTERS.filter((f) => counts[f.id] > 0);
  if (visible.length === 0) return null;

  return (
    <SidebarSection id="smart_filters" title="Smart Filters"
      activeLabel={reviewActive ? 'Review Queue' : visible.find(f => f.id === selectedId)?.label}>
      {visible.map((f) => (
        <div key={f.id} className={f.id === 'needs_review' && onOpenReview ? styles.withAction : undefined}>
          <button
            className={`${nav.row} ${f.id === 'needs_review' && onOpenReview ? styles.hasAction : ''} ${selectedId === f.id ? nav.selected : ''}`}
            aria-pressed={selectedId === f.id}
            onClick={() => onSelect(selectedId === f.id ? null : f.id)}
          >
            <span className={nav.label}>{f.label}</span>
            <span className={nav.count}>{counts[f.id]}</span>
          </button>
          {f.id === 'needs_review' && onOpenReview && (
            <button type="button" className={`${styles.reviewAction} ${reviewActive ? styles.active : ''}`}
              onClick={onOpenReview} aria-label="Open Review Queue" title="Open Review Queue"
              aria-current={reviewActive ? 'page' : undefined}>
              <ChevronRightIcon size={14} />
            </button>
          )}
        </div>
      ))}
    </SidebarSection>
  );
}
